export enum DimensionUnit {
  pixels = 'px',
  inches = 'in',
}
